import { UNPOPULATED_VALUE } from 'client/js/common/support/utils';
import AndFilter from 'client/js/common/support/utils/druid/filters/AndFilter';
import InFilter from 'client/js/common/support/utils/druid/filters/InFilter';
import { DomainAnalyticsService } from 'client/js/main/services/analytics/DomainAnalyticsService';
import dash_api from 'client/js/main/support/dash_api';
import type { ReportResponse } from 'client/js/main/types/analytics';
import type {
  GetDrillDownDataRequestPayload,
  GetDrillDownDataResponsePayload,
} from 'client/js/redux/domains/DrillDown/DrillDown.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import { deepCopy } from '../../../../../../shared/utils';

const GetDrillDownData = new ReduxAsyncAction<
  'GET_DRILL_DOWN_DATA',
  GetDrillDownDataRequestPayload,
  GetDrillDownDataResponsePayload
>('GET_DRILL_DOWN_DATA');

GetDrillDownData.registerRequest(async (args) => {
  const { reportQuery: originalReportQuery, nestLevel, filters } = args;
  const reportQuery = deepCopy(originalReportQuery);

  const analyticsReportEndpoint = DomainAnalyticsService.build().getAnalyticsEndpoint(reportQuery);

  if (!analyticsReportEndpoint) {
    return {
      data: [],
      filters,
    };
  }

  reportQuery.dimensions = [...reportQuery.dimensions].slice(0, nestLevel + 1);

  if (filters.length > 0) {
    reportQuery.drillDownFilter = new AndFilter([]);
  }

  filters.forEach((filter) => {
    const filterValue = filter.value === UNPOPULATED_VALUE ? null : filter.value;
    const newFilter = new InFilter(filter.dimension, [filterValue]);
    reportQuery.drillDownFilter?.fields.push(newFilter);
  });

  const { data } = await dash_api.post<ReportResponse>(analyticsReportEndpoint, reportQuery);
  return { data: data.data, filters };
});

export const GET_DRILL_DOWN_DATA = GetDrillDownData.actionNamespaceConstants;

export const getDrillDownData = GetDrillDownData.request;

export type GetDrillDownDataAction = Action<typeof GET_DRILL_DOWN_DATA.response> & {
  data: GetDrillDownDataResponsePayload;
};
